<template>
   <div style="height:100vh;">
    <div class="header pb-6 header-top">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row align-items-center py-4">
            <div class="col-lg-6 col-7">
              <!-- <h6 class="h2 text-white d-inline-block mb-0">Jourlys</h6> -->
              <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                <!-- <route-bread-crumb></route-bread-crumb> -->
              </nav>
            </div>
            <div class="col-lg-6 col-5 text-right">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid mt--6" style="background-color:#000000">
      <div class="card mb-4">
        <!-- Card header -->
        <div class="card-header">
          <h3 class="mb-0">Create New Advertisement</h3>
        </div>
        <!-- Card body -->
        <div class="card-body">
          <!-- Form groups used in grid -->
          <form class="needs-validation" @submit.prevent="handleCreate">
            <div class="row">
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="form-control-label">Title</label>
                  <div class="has-label">
                    <input class="form-control" name="title" id="title" type="text" placeholder="title" v-model="advertisement.title">
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="form-control-label">Format</label>
                  <div class="has-label">
                    <select class="form-control" v-model="advertisement.format">
                      <option value="square">Square</option>
                      <option value="banner">Banner</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="form-control-label">Image <span>*</span></label>
                  <div class="has-label">
                    <input class="form-control" name="image" id="image" type="file" placeholder="Image" required @change="onChangeFileUpload">
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="form-control-label">Link <span>*</span></label>
                  <div class="has-label">
                    <input class="form-control" name="link" id="link" type="text" placeholder="link" v-model="advertisement.link" required>
                  </div>
                </div>
              </div>
              <!-- <div class="col-md-12 col-sm-12">
                <div class="form-group">
                  <label class="form-control-label">Code</label>
                  <div class="has-label">
                    <textarea id="code" rows="8" placeholder="Write you code hare ..." class="form-control" v-model="advertisement.code" spellcheck="false"></textarea>
                  </div>
                </div>
              </div> -->
              <div class="col-md-12">
                  <base-button type="primary" native-type="submit" class="my-4"
                    >Create</base-button
                  >
                </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
// import { Form } from "vee-validate";
import RequestService from '../../services/request.service';
import { useToast } from "vue-toastification";
import Notification from "@/components/Notification";

export default {
  name: "form-elements",
  components: {
    RouteBreadCrumb,
    // Form,
  },
  data() {
    return {
      advertisement:{
	      title: '',
	      // code : '',
	      link : '',
        image : null, 
	      format : 'square',
      }
    };
  },
  methods: {
    async handleCreate() {
      const formData = new FormData();
      formData.append('title', this.advertisement.title);
      formData.append('format', this.advertisement.format);
      formData.append('image', this.advertisement.image);
      formData.append('link', this.advertisement.link);

      let response =  await RequestService.post2('advertisement/store',formData);
      if (response.status == "200") {
        this.message = response.data.message;
        this.runToast("top-right", "info");
        this.$router.push("/advertisement/index");
      } else {
        this.message = "Something went worng. Please try again.";
        this.runToast("top-right", "warning");
      }
    },
    onChangeFileUpload(event) {
      this.advertisement.image = event.target.files[0];
    },
    runToast(pos, type, ownText, ownIcon) {
      const icon = "ni ni-bell-55";
      const content = {
        component: Notification,
        props: {
          ownText: ownText,
          ownIcon: ownIcon,
          icon: icon,
          text: this.message,
          type: type,
        },
      };
      const toast = useToast();
      toast(content, {
        hideProgressBar: true,
        icon: false,
        closeButton: false,
        position: pos,
      });
    },
  },
};
</script>
